import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import listOrganizations from 'api/Organization/listOrganizations';
import { SearchFilter } from 'types/Filters';
import { OrganizationListItem } from 'types/Organization';

type SelectObject = {
    label: string;
    value: string;
    key: string;
};

export default function useOrganizationListDropdown() {
    const client = useClient();

    const { openAlert } = useAlert();
    const filter: SearchFilter = {
        term: '',
        page: 1,
        pageSize: 300,
        roles: ['Admin', 'Owner', 'Member'],
    };

    const [loading, setLoading] = useState(true);
    const [options, setOptions] = useState<SelectObject[]>([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await client?.query(listOrganizations(filter));
                if (!response.errors) {
                    const selectObjects: SelectObject[] = [];
                    response.data.listOrganizations.nodes.forEach(
                        (node: OrganizationListItem) => {
                            selectObjects.push({
                                label: node.label,
                                value: node.organizationUri,
                                key: node.organizationUri,
                            });
                        },
                    );
                    setOptions(selectObjects);
                } else {
                    setError(true);
                    openAlert({
                        message:
                            'Something went wrong... Could not retrieve organizations',
                        severity: 'alert',
                    });
                }
            } catch (error) {
                setError(true);
                openAlert({
                    message: 'An error occurred while fetching organizations',
                    severity: 'alert',
                });
            } finally {
                setLoading(false);
            }
        };

        if (client) {
            fetchData();
        }
    }, [client, openAlert]);

    return { options, error, loading };
}
